
import customBtn from '@/components/common/btn/custom-btn.vue'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import {
  getXunJiaInfo3Cookie,
  setXunJiaInfo3Cookie,
} from '@/composables/use-cookie-function'
import {
  countAd,
  fetchEncryptInfo,
  sendCaptcha,
  fetchTmLogin,
  fetchVerifyCtrl,
} from '@/http/api'

import {
  defineComponent,
  reactive,
  toRefs,
  computed,
  watch,
  ref,
  nextTick,
  onBeforeMount,
} from 'vue'
import { Toast } from 'vant'
import { isAndroid, isiOS, isPcApp } from '@/utils/runTimeEnv'
export default defineComponent({
  components: { customBtn },
  name: 'tm-login-popup',
  emits: ['toggleTmLoginPopup'],
  props: {
    enrollSgInfo: {
      // 弹窗留资车系信息
      type: Object,
    },
    isShowTmLoginPopup: {
      type: Boolean,
    },
  },
  setup(props: any, { emit }) {
    const phoneInputRef = ref()
    const route = useRoute()
    const store = useStore()
    const data = reactive({
      activityInfo: computed(() => store.state.activityInfo),
      locationInfo: computed(() => store.state.locationInfo),
      gamInfo: computed(() => store.state.gameInfo),
      captchaSwitch: computed(() => store.state.gameInfo.captchaSwitch),
      checkBoxNeedVerify: false,
      browserEnv: computed(() => store.state.browserEnv),
      appLoginCookieKey: computed(() => store.state.appLoginCookieKey),
      appLoginCookieValue: computed(() => store.state.appLoginCookieValue),
      isReadOnly: false,

      resTime: 0, // 验证码倒计时
      timer: null as any, // 验证码定时器
      postForm: {
        phone: '',
        captcha: '',
        source: 0,
        encryptPhone: '',
        showPhone: '' as any,
      },
    })
    watch(
      () => props.isShowTmLoginPopup,
      async nVal => {
        if (nVal === true) {
          let cookiePhoneObj: any = getXunJiaInfo3Cookie()
          if (data.browserEnv !== 1) {
            if (
              cookiePhoneObj &&
              cookiePhoneObj.phone &&
              cookiePhoneObj.encryptPhone
            ) {
              data.isReadOnly = true
              // 由于b端解密接口只能用在后端，此处不解密。
              data.postForm.phone = cookiePhoneObj.phone + '(上次使用)'
              data.postForm.encryptPhone = cookiePhoneObj.encryptPhone
            }
          }
          methods.getVerifyCtrl()
        }
      },
    )
    const methods = {
      handleKeyInput(e: any, type: string, maxLen: number) {
        e.target.value = e.target.value.replace(/[^\d]/g, '')
        if (e.target.value.length > maxLen) {
          e.target.value = e.target.value.slice(0, maxLen)
        }
        if (type === 'phone') {
          data.postForm.phone = e.target.value
        } else if (type === 'captcha') {
          data.postForm.captcha = e.target.value
        }
      },
      saveCookie(postForm: any) {
        // 报名成功-存储手机号，方便下次直接获取
        let cacheInfoType = ''
        if (process.env.VUE_APP_NODE_ENV === 'development') {
          cacheInfoType = 'dev'
        } else if (process.env.VUE_APP_NODE_ENV === 'qa') {
          cacheInfoType = 'qa'
        } else {
          cacheInfoType = 'prod'
        }
        postForm.phone =
          postForm.phone.slice(0, 3) + '****' + postForm.phone.slice(7)
        window.saveCacheInfo &&
          window.saveCacheInfo(
            postForm.phone,
            postForm.encryptPhone,
            cacheInfoType,
          )
      },
      // 清空电话号码
      clearPhone() {
        data.postForm.phone = ''
        data.postForm.encryptPhone = ''
        data.isReadOnly = false
        nextTick(() => {
          phoneInputRef.value.focus()
        })
      },
      // 获取验证码
      async getCaptcha() {
        data.postForm.phone = data.postForm.phone + ''
        if (data.resTime === 0) {
          if (data.timer) {
            clearInterval(data.timer)
          }
          if (!data.postForm.phone) {
            Toast('手机号不能为空')
            return
          }
          if (
            !data.postForm.phone.includes('*') &&
            !/^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/.test(
              data.postForm.phone,
            )
          ) {
            Toast('请输入正确的手机号码')
            return
          }
          /** * 获取加密手机号 s***/
          if (!data.postForm.phone.includes('*')) {
            let EtguardInfoRes: any = await fetchEncryptInfo({
              phones: window.encryStr(data.postForm.phone), // 手动输入的号码
            })
            if (EtguardInfoRes.code === 1) {
              data.postForm.encryptPhone = EtguardInfoRes.msg[0].encrypt
            } else {
              Toast('加密失败')
              return
            }
          }
          /** * 获取加密手机号 e***/
          const res = await sendCaptcha({
            phone: data.postForm.encryptPhone,
            encrypt: data.postForm.encryptPhone ? 1 : 0,
          })
          // 0-发送成功，1-手机号不能为空，2-请勿频繁发送验证码，3-超过限定次数，请明日再来，4-活动太火爆,请稍候再试
          if (res.data.code === 0) {
            Toast('发送成功')
            data.resTime = 60
            data.timer = setInterval(() => {
              if (data.resTime === 0) {
                clearInterval(data.timer)
                data.timer = null
              } else {
                data.resTime -= 1
              }
            }, 1000)
          } else {
            Toast(res.data.msg)
          }
        }
      },
      toggleTmLoginPopup(obj: any) {
        emit('toggleTmLoginPopup', {
          isShowTmLoginPopup: obj.isShowTmLoginPopup,
        })
        methods.clearForm()
      },
      statementClick() {
        data.checkBoxNeedVerify = !data.checkBoxNeedVerify
      },
      setPhoneSensitive(phone: any) {
        return phone.slice(0, 3) + '****' + phone.slice(7)
      },
      verifiyForm() {
        data.postForm.phone = data.postForm.phone + ''
        // 手机号校验
        if (!data.postForm.phone) {
          Toast('手机号不能为空')
          return
        }
        if (
          !data.postForm.phone.includes('*') &&
          !/^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/.test(
            data.postForm.phone,
          )
        ) {
          Toast('请输入正确的手机号码')
          return
        }
        // 验证码校验
        if (data.captchaSwitch && !data.postForm.captcha) {
          Toast('验证码不能为空')
          return
        }
        if (data.captchaSwitch && String(data.postForm.captcha).length < 6) {
          Toast('请输入正确的验证码')
          return
        }
        if (!data.checkBoxNeedVerify) {
          Toast('请勾选同意《个人信息披露及保护声明》')
          return
        }
        // 勾选框校验
        return true
      },
      clearForm() {
        data.postForm.phone = ''
        data.postForm.captcha = ''
        data.checkBoxNeedVerify = false
      },
      async handleLogin() {
        countAd(6561)
        if (!methods.verifiyForm()) return

        // 获取加密手机号
        let cookiePhoneObj = getXunJiaInfo3Cookie()
        let sensitivePhone =
          data.postForm.phone.slice(0, 3) +
          '****' +
          data.postForm.phone.slice(7, 11)
        let curPhone = ''
        if (data.postForm.phone.slice(0, 11).includes('*')) {
          curPhone =
            data.browserEnv === 1
              ? store.state.appPhone
                ? store.state.appPhone
                : data.postForm.phone.slice(0, 11)
              : data.postForm.phone.slice(0, 11)
        } else {
          curPhone = data.postForm.phone.slice(0, 11)
        }
        // 有cookie
        if (
          data.browserEnv !== 1 &&
          cookiePhoneObj &&
          cookiePhoneObj.phone &&
          cookiePhoneObj.encryptPhone &&
          cookiePhoneObj.phone === sensitivePhone
        ) {
          data.postForm.encryptPhone = cookiePhoneObj.encryptPhone
        } else {
          let EtguardInfoRes: any = await fetchEncryptInfo({
            phones: window.encryStr(curPhone), // 手动输入的号码
          })
          if (EtguardInfoRes.code === 1) {
            data.postForm.encryptPhone = EtguardInfoRes.msg[0].encrypt
          } else {
            Toast('加密失败')
            return
          }
        }

        // app发送收集的用户信息内容
        try {
          if (isPcApp()) {
            const userCollectInfo = {
              phoneNum: data.postForm.phone,
            }
            if (isiOS()) {
              window.webkit.messageHandlers.PCJSKit.postMessage({
                functionName: 'setUserCollectInfo',
                data: JSON.stringify(userCollectInfo),
              })
            } else if (isAndroid()) {
              window.PCJSKit.setUserCollectInfo(JSON.stringify(userCollectInfo))
            }
          }
        } catch (error) {
          console.log(error)
        }

        // 登录
        const loginRes: any = await fetchTmLogin({
          actId: route.query.actId,
          captcha: data.postForm.captcha,
          phone: data.postForm.encryptPhone,
        })
        if (loginRes.code === 200) {
          if (loginRes.data.code === 0) {
            Toast(loginRes.data.msg)
            store.commit('setGameLoginStatus', true)
            // 存入cookie
            setXunJiaInfo3Cookie({
              phone: curPhone,
              encryptPhone: data.postForm.encryptPhone,
            })
            // 更新游戏信息
            store.dispatch('getGameInfo', {
              actId: route.query.actId,
              phone: data.postForm.encryptPhone,
            })
            methods.toggleTmLoginPopup({ isShowTmLoginPopup: false })
          } else {
            Toast(loginRes.data.msg)
          }
        } else {
          Toast(loginRes.messsage)
        }
      },
      toggleSensitivePhoneInput() {
        setTimeout(() => {
          // phoneInputRef.value.focus()
          nextTick(() => {
            phoneInputRef.value.focus()
          })
          data.isReadOnly = false
        })
      },
      // 跳转个人信息保护声明
      toLinkStatement() {
        const appUrl =
          'pcautobrowser://more/?uri=https://www1.pcauto.com.cn/zt/gz20171127/declare/app.html?hiddenShareBtn=1'
        const wapUrl =
          'https://www1.pcauto.com.cn/zt/gz20171127/declare/wap.html'
        const wxUrl =
          'https://www1.pcauto.com.cn/zt/gz20171127/declare/app.html'
        if (data.browserEnv === 3) {
          window.location.href = wapUrl
        } else if (data.browserEnv === 1) {
          window.location.href = appUrl
        } else {
          window.location.href = wxUrl
        }
      },

      // 获取验证码和勾选框状态
      async getVerifyCtrl() {
        if (data.browserEnv === 1) {
          // app
          data.postForm.source = 2
        } else if (data.browserEnv === 2 || data.browserEnv === 3) {
          // h5或微信浏览器
          data.postForm.source = 1
        }
        const res: any = await fetchVerifyCtrl({ source: data.postForm.source })
        if (res.code === 200) {
          data.checkBoxNeedVerify = res.data.checkBoxNeedVerify
        }
      },
    }

    onBeforeMount(() => {
      methods.getVerifyCtrl()
    })
    return {
      ...toRefs(data),
      ...methods,
      phoneInputRef,
    }
  },
})
